import {IAppEntity} from "../../../config/entities";
import React, {useEffect, useState} from "react";

interface IProps {
    id?: string;
    entity: IAppEntity;
}

export type DocumentDetailViewContextValue = {
    id?: undefined,
    isLoading: boolean,
    isSaving: boolean,
    isDeleting: boolean,
    isPosting: boolean,
}

const defaultContextValue: DocumentDetailViewContextValue = {
    isLoading: false,
    isSaving: false,
    isDeleting: false,
    isPosting: false,
}

export const DocumentDetailViewContext = React.createContext<DocumentDetailViewContextValue>(defaultContextValue);

export const DocumentDetailView = ({entity, id}: IProps) => {
    const [documentContext, setDocumentContext] = useState<DocumentDetailViewContextValue>(defaultContextValue);

    if (!entity.getDetailView) {
        return <>Not implemented!</>
    }

    return (
        <>
            <DocumentDetailViewContext.Provider value={documentContext}>
                <div className={"main-container container-fluid"}>
                    <div className={"card card-body border"}>
                        {entity.getDetailView(id)}
                    </div>
                </div>
            </DocumentDetailViewContext.Provider>
        </>
    )
}